const globalAccess = {
  init() {
    this.elements = document.querySelectorAll(".js-global-access");
    this.price = 99;
    this.pricePlaceholder = "{price}";

    if (this.elements.length) {
      this.addEvents();
    }
  },

  addEvents() {
    this.elements.forEach((element) => {
      const form = element.closest("form");
      const wrapper = form.querySelector(".js-global-access-message-wrapper");
      const termsTxt = form.querySelector(
        ".js-global-access-message-wrapper-terms"
      );
      const locationSelect = form.querySelector(".f_location_id");
      const termSelect = form.querySelector('[id*="term-length"]');
      const total = form.querySelector(".js-purchase-total");

      element.addEventListener("change", () => {
        let price = 0;
        let discount = 0;

        if (termSelect.value.indexOf("6") > -1) discount = 5;
        if (termSelect.value.indexOf("12") > -1) discount = 10;

        let label = element.dataset.label;

        if (termSelect.value && label) {
          //Global Access : YES
          if (
            form
              .querySelector(".js-global-access:checked")
              .value.indexOf("Yes") > -1
          ) {
            price += this.price;
          }

          let location_price_elem = locationSelect.querySelector(
            `option[value="${locationSelect.value}"]`
          );

          if (location_price_elem) {
            if (location_price_elem.dataset.access) {
              let location_pice = location_price_elem.dataset.access.replace(
                /[^\d.-]/g,
                ""
              );

              let location_currency = this.getCurrencySymbol(
                location_price_elem.dataset.access
              )
                ? this.getCurrencySymbol(location_price_elem.dataset.access)
                : "$";

              location_pice = Number(location_pice);

              if (discount) {
                location_pice = (location_pice * (100 - discount)) / 100;
              }

              price += parseInt(location_pice);
              price = location_currency + price;
              label = label.replace(this.pricePlaceholder, price);
              this.setWrapperContent(wrapper, label);
              termsTxt.classList.remove("d-none");
              wrapper.classList.remove("d-none");
              total.value = price;
            } else {
              this.setWrapperContent(wrapper, "");
              termsTxt.classList.add("d-none");
              wrapper.classList.add("d-none");
              total.value = price;
            }
          }
        } else {
          this.setWrapperContent(wrapper, "");
          total.value = price;
        }
      });

      termSelect &&
        termSelect.addEventListener("change", () => {
          element.dispatchEvent(new Event("change"));
        });

      locationSelect &&
        locationSelect.addEventListener("change", () => {
          element.dispatchEvent(new Event("change"));
        });

      element.dispatchEvent(new Event("change"));
    });
  },

  setWrapperContent(wrapper, text) {
    wrapper.innerText = text;
  },

  getCurrencySymbol(str) {
    //replace all numbers, spaces, commas, and periods with an empty string
    //we should only be left with the currency symbols
    return str.replace(/[\d\., ]/g, ""); // eslint-disable-line
  },
};

export default globalAccess;
